import React, { useState } from 'react';

import RadioInput from '@core/components/radioinput/RadioInput';
import Checkbox from '@core/components/checkbox/Checkbox';
import { SurveyQuestionTypes } from 'constants/Survey';

import ActionButton from '@core/components/actionbutton/ActionButton';
import TextAreaInput from '@core/components/textareainput/TextAreaInput';
import TextInput from '../textinput/TextInput';

import classes from './SurveyQuestion.module.scss';



const SurveyQuestion = ({ question, submitQuestion }) => {
    const [selectedChoices, setSelectedChoices] = useState([]);
    const [textValue, setTextValue] = useState('');

    const handleChoiceChange = (choiceIds) => {
        setTimeout(() => {
            submitQuestion(choiceIds);
        }, 300);
    };

    const handleCheckboxChange = (choiceId) => {
        setSelectedChoices((prev) =>
            prev.includes(choiceId)
                ? prev.filter((id) => id !== choiceId)
                : [...prev, choiceId]
        );
    };

    const handleTextSubmit = () => {
        submitQuestion(textValue);
    };

    return (
        <div className={classes['wrapper']}>
            <h3>{question.text}</h3>
            <div className='d-flex flex-column gap-2'>
                {question.type === SurveyQuestionTypes.SINGLE_CHOICE && (
                    <>
                        {question.choices.map((choice) => (
                            <RadioInput
                                key={choice.id}
                                input={{
                                    name: `choices`,
                                    label: choice.text,
                                    id: `choice_${choice.id}`,
                                }}
                                type='survey'
                                onChange={() => handleChoiceChange([choice.id])}
                            />
                        ))}
                    </>
                )}
                {question.type === SurveyQuestionTypes.MULTI_CHOICE && (
                    <>
                        {question.choices.map((choice) => (
                            <Checkbox
                                key={choice.id}
                                input={{
                                    name: `choices`,
                                    label: choice.text,
                                    id: `choice_${choice.id}`,
                                }}
                                type='survey'
                                onChange={() => handleCheckboxChange(choice.id)}
                            />
                        ))}
                        <div className={classes['action-wrapper']}>
                            <ActionButton
                                onClick={() => handleChoiceChange(selectedChoices)}
                                disabled={selectedChoices.length === 0}
                            >
                                Next
                            </ActionButton>
                        </div>
                    </>
                )}
                {question.type === SurveyQuestionTypes.TEXT && (
                    <>
                        <div className={classes['text-question-wrapper']}>
                            <TextAreaInput
                                input={{
                                    type: 'text',
                                    label: '',
                                    placeholder: 'Answer here',
                                    id: 'survey-text',
                                    value: textValue,
                                    onChange: (e) => setTextValue(e.target.value),
                                }}
                                maxLength={500}
                            />
                        </div>
                        <div className={classes['action-wrapper']}>
                            <ActionButton
                                onClick={handleTextSubmit}
                                disabled={textValue.trim() === ''}
                            >
                                Next
                            </ActionButton>
                        </div>
                    </>
                )}
                {question.type === SurveyQuestionTypes.NUMBER && (
                    <>
                        <div className={classes['number-question-wrapper']}>
                            <TextInput
                                input={{
                                    type: 'number',
                                    label: '',
                                    placeholder: 'Answer here',
                                    id: 'survey-number',
                                    value: textValue,
                                    onChange: (e) => setTextValue(e.target.value),
                                }}
                            />
                         
                        </div>
                        <div className={classes['action-wrapper']}>
                            <ActionButton
                                onClick={handleTextSubmit}
                                disabled={textValue.trim() === ''}
                            >
                                Next
                            </ActionButton>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SurveyQuestion;